"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DubbingListRequestFilterByCreator = void 0;
exports.DubbingListRequestFilterByCreator = {
    Personal: "personal",
    Others: "others",
    All: "all",
};
